import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { bindFunctionsToThis } from '../../extensions';

@Component({
    selector: 'ig-no-content',
    templateUrl: './no.content.component.html',
    styleUrls: ['./no.content.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NoContentComponent {
    @Input() public tip: string;
    @Input() public fontSize = '7rem';

    constructor() {
        bindFunctionsToThis(this);
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/no.content.tip/no.content.component.ts